var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudCeilingTomorrowio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    className: "weather-filter-parameter__icon--Huru",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0007,14.5004L1.0007,14.5004c0-0.2761,0.2239-0.5,0.5-0.5h21 c0.2761,0,0.5,0.2239,0.5,0.5c0,0.2761-0.2239,0.5-0.5,0.5h-21C1.2246,15.0004,1.0007,14.7765,1.0007,14.5004z M10.2307,20.9794 c0,1.096-0.876,1.987-1.969,2.02v0.001h-5.785c-0.815,0-1.476-0.658-1.476-1.47c0-0.641,0.412-1.186,0.987-1.387 c-0.002-0.047-0.003-0.095-0.003-0.143c0-1.657,1.35-3,3.016-3c1.309,0,2.423,0.83,2.84,1.99c0.117-0.02,0.237-0.031,0.359-0.031 C9.3217,18.9594,10.2307,19.8634,10.2307,20.9794 M21.9138,5.1826c-0.688-0.7208-1.6337-1.1687-2.6777-1.1885 c-0.3904-0.7914-0.9594-1.4703-1.6497-1.98C16.7196,1.3743,15.6622,1,14.5219,1c-1.485,0-2.8303,0.6331-3.7966,1.6953 C9.9177,3.5831,9.374,4.7753,9.2562,6.146c-0.3568,0.2268-0.666,0.5277-0.9068,0.8836c-0.3458,0.511-0.5507,1.1349-0.5507,1.8088 c0,0.8674,0.3389,1.6511,0.8809,2.2191c0.5585,0.5852,1.3313,0.9429,2.1821,0.9429h8.4053c1.0528-0.0294,2.004-0.4935,2.6884-1.2333 c0.6629-0.7166,1.0745-1.6926,1.0745-2.7706C23.0299,6.8967,22.6011,5.9027,21.9138,5.1826z M20.4873,9.4092 c-0.3359,0.3628-0.7803,0.5723-1.2539,0.5913h-8.3721c-0.3701,0-0.6191-0.2031-0.7354-0.3242 C9.915,9.4556,9.7988,9.1572,9.7988,8.8384c0-0.3154,0.1123-0.5479,0.207-0.6875c0.0869-0.1284,0.1982-0.2378,0.3242-0.3179 l0.834-0.5308l0.084-0.9844c0.0771-0.8857,0.4072-1.6729,0.957-2.2769C12.8154,3.3696,13.6387,3,14.5215,3 c0.6758,0,1.3242,0.2153,1.876,0.623c0.4375,0.3228,0.7988,0.7568,1.0449,1.2563l0.5391,1.0918l1.2178,0.0225 c0.4756,0.0088,0.9258,0.2114,1.2686,0.5703c0.3623,0.3799,0.5625,0.8887,0.5625,1.4326 C21.0303,8.5288,20.8369,9.0303,20.4873,9.4092z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudCeilingTomorrowio);
export default __webpack_public_path__ + "static/media/cloud-ceiling-tomorrowio.8aafe5b4028e9c3cfaee85a9c8cbe3e7.svg";
export { ForwardRef as ReactComponent };